import { rbacRequests } from './rbac.js';

const service = {
    rbac: rbacRequests,
};

export { service as default };
